import React from 'react';
import {
  makeStyles,
} from '@material-ui/core';
import Header from './Header';
import HorseDetails from './HorseDetails';
import Footer from './Footer';

const useStyles = makeStyles(() => ({
  wrapper: {
    fontSize: '16px',
    width: '420px',
    fontFamily: 'Roboto, sans-serif',
  },
}));

const Permit = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <Header />
      <HorseDetails />
      <Footer />
    </div>
  );
};

export default Permit;
